import Vue from 'vue';
import Axios from 'axios';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';
import { getUrlParams } from '../../../helpers/pagination';

const state = {
  countries: {
    isBusy: false,
    data: null,
    error: null
  },
  find_results: {
    isBusy: false,
    data: null,
    error: null,
    request: null
  }
};

const getters = {
  countriesPagination: state => {
    if (state.countries.data)
      return state.countries.data.pagination;

    return '';
  },
  countriesTotal: (state, getters) => {
    if (getters.countriesPagination)
      return getters.countriesPagination.totalCount;

    return undefined;
  }
}

const mutations = {
  LOAD_COUNTRIES_BUSY: (state, payload) => {
    state.countries.isBusy = payload;
  },
  UPDATE_COUNTRIES_BUSY: (state, payload) => {
    state.countries.isBusy = payload;
  },
  LOAD_COUNTRIES_SUCCESS: (state, payload) => {
    state.countries.data = payload.data;
    state.countries.error = null;
  },
  UPDATE_COUNTRIES_SUCCESS: (state, data) => {
    state.countries.data.data.forEach(item => {
      if (!data.ids || data.ids.indexOf(item.id) !== -1)
        item.household = data.households;
    });

    state.countries.error = null;
  },
  LOAD_COUNTRIES_FAIL: (state, payload) => {
    state.countries.data = null;
    state.countries.error = payload;
  },
  UPDATE_COUNTRY: (state, { country, households }) => {
    let updateCountry = state.countries.data.data.find( item => {
      item.id === country.id; 
    });

    if (updateCountry) updateCountry.households = households;
  }
};

const actions = {
  getCountries: (
    { commit, rootState, state },
    { projectId, pagination, name = '' }
  ) => {
    commit('LOAD_COUNTRIES_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    let url = `${API_HOST}/analysis/${projectId}/countries/households?`;
    url += getUrlParams(pagination);
    if (name) url += `&name=${name}`

    Axios.get(url, config)
      .then(response => {
        let data = response.data;

        if (pagination.page > 1)
          data.data.data = [...state.countries.data.data, ...data.data.data];

        commit('LOAD_COUNTRIES_SUCCESS', data);
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('LOAD_COUNTRIES_FAIL', error);
      })
      .finally(() => {
        commit('LOAD_COUNTRIES_BUSY', false);
      });
  },

  updateCountries: ({ commit, rootState }, { projectId, data }) => {
    commit('UPDATE_COUNTRIES_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return new Promise((resolve, reject) => {
      Axios.put(
        `${API_HOST}/analysis/${projectId}/countries/households`, data, config
      )
        .then(response => {
          Vue.notify({
            group: 'store_notifications',
            type: 'success',
            text: i18n.tc("country.form.message.updated",
              data.ids ? data.ids.length : 2
            )
          });
          commit('UPDATE_COUNTRIES_SUCCESS', data);
          resolve(response.data);
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t("messages.request.error")
          });

          console.error(error);
          commit('UPDATE_CATEGORY_FAIL', error);
          reject(error);
        })
        .finally(() => commit('UPDATE_COUNTRIES_BUSY', false));
    });
  },

  updateCountryHouseholds: ({ commit }, { country, households }) => {
    commit('UPDATE_COUNTRY', { country, households })
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};